import { UserRole } from '../types';

// Owner (2026-10-17) sits above super admin. Everywhere the app grants a super admin something, an
// owner gets it too — so those checks ask isSuperTier. Only three things are the owner's alone: the
// full customer list, making or changing super admins and owners, and the Customer lookup switch.
export const isOwner = (role: string | null | undefined): boolean => role === UserRole.OWNER;

export const isSuperTier = (role: string | null | undefined): boolean =>
  role === UserRole.OWNER || role === UserRole.SUPER_ADMIN;
